const Body = (props) => {
    return (
        props.children
    )
}

export default Body;